import { c as _c } from "react/compiler-runtime";
import { DownOutlined } from '@ant-design/icons';
import { ConfigProvider, Popover, Slider } from 'antd';
import type { TooltipRef } from 'antd/lib/tooltip';
import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';
type PriceSelectValue = [min: number, max: number];
type PriceSelectProps = {
  value?: PriceSelectValue;
  onChange?: (value: PriceSelectValue) => void;
  onChangeComplete?: (value: PriceSelectValue) => void;
  min: number;
  max: number;
  step: number;
  placeholder?: string;
  className?: string;
  currency: string;
  defaultValue: PriceSelectValue;
  open?: boolean;
  autoAdjustOverflow?: boolean;
  popupClassName?: string;
};
export const PriceSelect = t0 => {
  const $ = _c(43);
  const {
    open,
    autoAdjustOverflow,
    value,
    onChange,
    onChangeComplete,
    min,
    max,
    step,
    placeholder,
    className: t1,
    currency,
    defaultValue,
    popupClassName
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const containerRef = useRef(null);
  const popoverRef = useRef(null);
  const [localOpen, setLocalOpen] = useState(false);
  const t = useTranslations("experiences.filters");
  const t2 = `relative flex h-12 md:h-14 ${className}`;
  let t3;
  let t4;
  if ($[0] !== open) {
    t3 = _open => setLocalOpen(open ?? _open);
    t4 = _open_0 => setLocalOpen(open ?? _open_0);
    $[0] = open;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      components: {
        Slider: {
          railSize: 8,
          handleSize: 24,
          handleSizeHover: 24,
          handleColor: "#4729A0 !important",
          handleActiveColor: "#4729A0",
          handleActiveOutlineColor: "#4729A040"
        },
        Tooltip: {
          colorBgBase: "#4729A0"
        }
      }
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== onChangeComplete) {
    t6 = onChangeComplete && (value_0 => onChangeComplete([value_0[0], value_0[1]]));
    $[4] = onChangeComplete;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onChange) {
    t7 = onChange && (value_1 => onChange([value_1[0], value_1[1]]));
    $[6] = onChange;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      rail: {
        backgroundColor: "#212233",
        borderRadius: "4px"
      },
      track: {
        backgroundImage: "linear-gradient(90deg, #2A72FD 0%, #4A2AA8 50%, #291C57 100%)"
      }
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => popoverRef.current?.popupElement ?? document.body;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== localOpen) {
    t10 = {
      getPopupContainer: t9,
      open: localOpen,
      color: "#6D6F9C1A",
      arrow: false,
      placement: "bottom",
      rootClassName: "\n                  [&_.ant-tooltip-inner]:rounded-lg\n                  [&_.ant-tooltip-inner]:border\n                  [&_.ant-tooltip-inner]:border-[#6D6F9C1A]\n                  [&_.ant-tooltip-inner]:cursor-pointer\n                  [&_.ant-tooltip-inner]:py-0\n                  [&_.ant-tooltip-inner]:px-3\n                  [&_.ant-tooltip-inner]:h-10\n                  [&_.ant-tooltip-inner]:flex\n                  [&_.ant-tooltip-inner]:items-center\n                  [&_.ant-tooltip-inner]:justify-center\n                  [&:not(:last-child)_.ant-tooltip-content]:-translate-y-[calc(100%+24px+8px)]\n                "
    };
    $[10] = localOpen;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== defaultValue || $[13] !== max || $[14] !== min || $[15] !== step || $[16] !== t10 || $[17] !== t6 || $[18] !== t7 || $[19] !== value) {
    t11 = <ConfigProvider theme={t5}><Slider range={true} onChangeComplete={t6} onChange={t7} value={value} min={min} max={max} step={step} styles={t8} defaultValue={defaultValue} rootClassName="my-11" tooltip={t10} /></ConfigProvider>;
    $[12] = defaultValue;
    $[13] = max;
    $[14] = min;
    $[15] = step;
    $[16] = t10;
    $[17] = t6;
    $[18] = t7;
    $[19] = value;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => containerRef.current ?? document.body;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = `
          w-full 
          [&>.ant-popover-content]:-mt-1
          [&>.ant-popover-content>.ant-popover-inner]:rounded-b-lg
          [&>.ant-popover-content>.ant-popover-inner]:px-5
          [&>.ant-popover-content>.ant-popover-inner]:pt-4
          [&>.ant-popover-content>.ant-popover-inner]:pb-5
          ${popupClassName}
        `;
  let t14;
  if ($[22] !== currency || $[23] !== placeholder || $[24] !== t || $[25] !== value) {
    t14 = !value ? <span className="flex-1 text-input text-[#A0A3E2]">{placeholder}</span> : <div className="flex flex-1 items-center gap-2 text-input text-[#A0A3E2]"><span>{t("filter.priceLabel")}</span><div className="flex flex-1 items-center gap-0.5"><span className="font-semibold text-white">{value[0]}-{value[1]}</span><span className="font-medium">{currency}</span></div></div>;
    $[22] = currency;
    $[23] = placeholder;
    $[24] = t;
    $[25] = value;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== open) {
    t15 = !open && <DownOutlined className="size-6 text-[#A0A3E2]" />;
    $[27] = open;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <div className={"\n            z-40 flex flex-1 items-center rounded-lg border border-[#A0A3E280] pl-5\n            pr-2\n            [&.ant-popover-open]:rounded-b-none\n            [&.ant-popover-open]:border-[#FFFFFF1F]\n            [&.ant-popover-open]:border-x-[#392F99]\n            [&.ant-popover-open]:border-t-[#392F99]\n            [&.ant-popover-open]:bg-[#4A2AA8]\n          "}>{t14}{t15}</div>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== autoAdjustOverflow || $[33] !== open || $[34] !== t11 || $[35] !== t13 || $[36] !== t16 || $[37] !== t3 || $[38] !== t4) {
    t17 = <Popover ref={popoverRef} open={open} onOpenChange={t3} afterOpenChange={t4} content={t11} autoAdjustOverflow={autoAdjustOverflow} trigger="click" arrow={false} placement="bottom" getPopupContainer={t12} rootClassName={t13} color="#1A1B2A" zIndex={30}>{t16}</Popover>;
    $[32] = autoAdjustOverflow;
    $[33] = open;
    $[34] = t11;
    $[35] = t13;
    $[36] = t16;
    $[37] = t3;
    $[38] = t4;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17 || $[41] !== t2) {
    t18 = <div className={t2} ref={containerRef}>{t17}</div>;
    $[40] = t17;
    $[41] = t2;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};